export * from "./date";
export * from "./profile";

export const truncate = (text, length = 50) => {
    if (text.length <= length) {
        return text;
    }

    return text.substring(0, length) + "...";
};

export const download = (url: string) => {
    let a = document.createElement("a");
    a.href = url;
    a.download = url.split("/").pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
